module.exports = __webpack_public_path__ + "static/img/login_tip.46efb13.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_tip.png
// module id = ju9j
// module chunks = 1